import {z as r} from 'zod';

import {ReviewsAnalysisModeEnum} from '../reivew-analysis-const';
import {SentimentEnum} from '../review-sentiment/review-sentiment-type';

export enum ReviewRateEnum {
    Rate5 = '5',
    Rate4 = '4',
    Rate3 = '3',
    Rate2 = '2',
    Rate1 = '1',
}

const reviewRateCompetitorSchema = r.object({
    brandId: r.number(),
    avgRating: r.number(),
});

const reviewRateCompetitorByTimeSchema = r.object({
    date: r.string(),
    brands: r.array(reviewRateCompetitorSchema),
});

type ReviewRateCompetitorByTimeType = r.infer<typeof reviewRateCompetitorByTimeSchema>;

export type ReviewRateCompetitorsResponseType = Array<ReviewRateCompetitorByTimeType>;

export const reviewRateCompetitorsResponseSchema = r.array(reviewRateCompetitorByTimeSchema);

export type ReviewsAnalysisRateQueryType = {
    limit?: number;
    mode?: ReviewsAnalysisModeEnum;
    brandIds?: Array<number>;
    companyIds?: Array<number>;
    startDate: string | null;
    endDate: string | null;
    sentiments: Array<SentimentEnum>;
    sources: Array<number>;
    tags: Array<string>;
    phrases: Array<string>;
    topics: Array<string>;
    userTagsIds: Array<number>;
    aspectIds: Array<number>;
    rating: Array<ReviewRateEnum>;
    withAnswers: boolean | null;
    withText: boolean | null;
    ableToReply: boolean | null;
    target: string | null;
    useDeleted: boolean | null;
};
